import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-resolve-filled.tsx
/**
* icon.24.resolve.filled
*
* Keywords: checkmark, circle, complete, confirm, approved, verified, success, selection
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQuMDAxIDcgNyAwIDAgMSAwLTE0bTMuMjUyIDMuNTY5YS41LjUgMCAwIDAtLjY4My4xOGwtMy4xNDIgNS4zODMtMi4wNDMtMi40NTJhLjUuNSAwIDAgMC0uNzY3LjY0bDIuNSAzYS41LjUgMCAwIDAgLjgxNS0uMDY4bDMuNS02YS41LjUgMCAwIDAtLjE4LS42ODMiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1200
*/
const Icon24ResolveFilled = memo(function Icon24ResolveFilled(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14.001 7 7 0 0 1 0-14m3.252 3.569a.5.5 0 0 0-.683.18l-3.142 5.383-2.043-2.452a.5.5 0 0 0-.767.64l2.5 3a.5.5 0 0 0 .815-.068l3.5-6a.5.5 0 0 0-.18-.683"
		})
	});
});
//#endregion
export { Icon24ResolveFilled };

//# sourceMappingURL=icon-24-resolve-filled.js.map